import { render, staticRenderFns } from "./ScheduleSettings.vue?vue&type=template&id=5c8a1d09&scoped=true&"
import script from "./ScheduleSettings.vue?vue&type=script&lang=js&"
export * from "./ScheduleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a1d09",
  null
  
)

export default component.exports